import { SignUpForm } from "./signup-form";
import { ReactComponent as ISOLogoIcon } from "../assets/isotipo.svg";
import bgRegister from "../assets/bgRegister.jpg";

export const SignUpWrapper = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-cover bg-center relative bg-fixed overflow-hidden" style={{ backgroundImage: `url(${bgRegister})` }}>
      <div className="absolute inset-0 bg-black opacity-50 z-0" />
      
      <div className="relative w-full max-w-md p-8 bg-[#F8F9FA] shadow-xl rounded-2xl bg-opacity-80 text-gray-900 border border-gray-300 z-10">
        <h2 className="text-2xl font-semibold text-center mb-6">Registrarse</h2>
        <SignUpForm />
        
        <div className="mt-6 text-center text-sm text-gray-600">
          <p>¿Ya tienes cuenta? <a href="/signin" className="text-[#6C757D] hover:underline">Inicia sesión</a></p>
        </div>

        <div className="mt-6 flex items-center justify-center gap-2 text-gray-600 text-xs">
          <span>Powered by</span>
          <ISOLogoIcon className="w-8" />
          Hiva
        </div>
      </div>
    </div>
  );
};
